import { render, staticRenderFns } from "./LoginSubparceiros.vue?vue&type=template&id=fc0a471c&scoped=true"
import script from "./LoginSubparceiros.vue?vue&type=script&lang=js"
export * from "./LoginSubparceiros.vue?vue&type=script&lang=js"
import style0 from "./LoginSubparceiros.vue?vue&type=style&index=0&id=fc0a471c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0a471c",
  null
  
)

export default component.exports